import { get } from '@utils/axios';

const query = (payload = {}) => new URLSearchParams(
  Object.entries(payload).filter(([, value]) => value !== undefined && value !== '')
).toString();

export const getMyRequestsReq = (payload) => get(`my-work/requests?${query(payload)}`);
export const getMyApprovalsReq = (payload) => get(`my-work/approvals?${query(payload)}`);
export const getMyApprovalsFilterReq = () => get(
  `filters?${localStorage.getItem('company_id') || 1}&fields=page=1&filters=supporting_fields_|employments,request_status;organization_structure_fields_|location,branch,department;`
);
